import BenchmarkChoose from './benchmark-choose'

export default BenchmarkChoose;